import { render, staticRenderFns } from "./onlineConsultation.vue?vue&type=template&id=b87e312a&scoped=true&"
import script from "./onlineConsultation.vue?vue&type=script&lang=js&"
export * from "./onlineConsultation.vue?vue&type=script&lang=js&"
import style0 from "./onlineConsultation.vue?vue&type=style&index=0&id=b87e312a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87e312a",
  null
  
)

export default component.exports